import { useEffect, useRef, useState } from 'react';
import Nav from './components/Nav';
import AlbumPopup from './components/AlbumPopup';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import Bio from './pages/Bio';
import Contact from './pages/Contact';
import { ARTIST, LINKS } from './config';
import swatches from './assets/swatches.png';

const FADE_OUT = 150;

const PAGES = { home: Home, gallery: Gallery, bio: Bio, contact: Contact };

const readHash = () => {
  const id = window.location.hash.replace(/^#\/?/, '');
  return PAGES[id] ? id : 'home';
};

// Instagram in the middle.
const FOOTER_LINKS = ['spotify', 'instagram', 'youtube'];

function Footer() {
  return (
    <footer className="mt-auto bg-black text-bone/60">
      <div className="flex flex-col items-center gap-6 px-5 pb-12 pt-6 font-mono text-[11px] uppercase tracking-[0.25em] md:flex-row md:justify-between md:px-10 md:pb-6">
        {/* On mobile the links come first and the swatches sit underneath them. */}
        <img src={swatches} alt="" className="order-2 w-20 md:order-none" />
        <ul className="order-1 flex flex-wrap justify-center gap-x-6 gap-y-2 font-times text-xl normal-case tracking-normal md:order-none md:text-base">
          {FOOTER_LINKS.map((name) => (
            <li key={name}>
              <a href={LINKS[name]} target="_blank" rel="noopener noreferrer" className="block py-2 transition-colors hover:text-mustard md:py-0">
                {name}
              </a>
            </li>
          ))}
        </ul>
        <span className="order-3 font-times text-base normal-case tracking-normal md:order-none">
          © {new Date().getFullYear()} {ARTIST}
        </span>
      </div>
    </footer>
  );
}

function App() {
  const [page, setPage] = useState(readHash);
  // Where the nav is heading; it leads `page` while the old page fades out.
  const [target, setTarget] = useState(page);
  const [leaving, setLeaving] = useState(false);
  const timer = useRef();

  useEffect(() => {
    const onHash = () => {
      const next = readHash();
      clearTimeout(timer.current);
      setTarget(next);
      setLeaving(true);
      // Fade the old page out, then swap; the new one fades up on mount (animate-page-in).
      timer.current = setTimeout(() => {
        setPage(next);
        setLeaving(false);
        window.scrollTo(0, 0);
      }, FADE_OUT);
    };
    window.addEventListener('hashchange', onHash);
    return () => {
      window.removeEventListener('hashchange', onHash);
      clearTimeout(timer.current);
    };
  }, []);

  const Page = PAGES[page];

  return (
    <div className="flex min-h-screen min-h-svh flex-col">
      <Nav page={target}>
        <AlbumPopup />
      </Nav>
      <div
        key={page}
        className={`flex flex-1 flex-col bg-black animate-page-in transition-opacity duration-150 motion-reduce:animate-none ${
          leaving ? 'opacity-0' : ''
        }`}
      >
        <Page />
        {page !== 'home' && <Footer />}
      </div>
      <div
        aria-hidden="true"
        className="pointer-events-none fixed -inset-1/2 z-[100] animate-grain bg-grain opacity-[0.05] motion-reduce:animate-none"
      />
    </div>
  );
}

export default App;
